import React, { useState } from "react";

const blogData = [
  {
    title: "Why Project-Based Learning is Important for IT Students",
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80",
    short:
      "Understand how real-world projects prepare students for the IT industry.",
    content:
      "Project-based learning helps students gain hands-on experience, problem-solving skills, and confidence. It bridges the gap between theory and industry requirements, making students job-ready.",
    date: "Jan 5, 2026",
  },
  {
    title: "Full Stack Developer Roadmap for Beginners",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80",
    short:
      "A step-by-step guide to becoming a full stack developer.",
    content:
      "This blog explains the learning path for full stack development including frontend, backend, databases, APIs, and deployment strategies.",
    date: "Jan 2, 2026",
  },
  {
    title: "Java Full Stack vs Python Full Stack: Which is Better?",
    image:
      "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=800&q=80",
    short:
      "Compare Java and Python full stack development career options.",
    content:
      "Java Full Stack is widely used in enterprise applications, while Python Full Stack is popular in startups and rapid development. Both have strong career opportunities.",
    date: "Dec 28, 2025",
  },
  {
    title: "Top Skills Every Web Developer Must Have",
    image:
      "https://images.unsplash.com/photo-1504805572947-34fad45aed93?auto=format&fit=crop&w=800&q=80",
    short:
      "Technical and soft skills required to succeed as a web developer.",
    content:
      "Apart from coding, developers should have problem-solving ability, communication skills, version control knowledge, and debugging expertise.",
    date: "Dec 25, 2025",
  },
  {
    title: "Why React.js is So Popular in Web Development",
    image:
    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80",
    short:
      "Reasons behind React’s popularity among developers.",
    content:
      "React offers reusable components, fast performance with virtual DOM, and strong community support, making it a preferred frontend library.",
    date: "Dec 20, 2025",
  },
  {
    title: "Career Opportunities After Learning MERN Stack",
    image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80",
    short:
      "Explore job roles available after MERN stack training.",
    content:
      "MERN stack developers can work as full stack developers, frontend developers, backend developers, or freelance web developers.",
    date: "Dec 18, 2025",
  },
  {
    title: "Importance of Internships for Computer Science Students",
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80",
    short:
      "How internships help students gain industry exposure.",
    content:
      "Internships provide real-world experience, improve technical skills, and increase chances of placement after graduation.",
    date: "Dec 15, 2025",
  },
  {
    title: "Common Mistakes Beginners Make While Learning Programming",
     image: "https://images.unsplash.com/photo-1515879218367-8466d910aaa4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  short: "Avoid these common errors while starting your coding journey.",
  content:
    "Skipping basics, lack of practice, fear of errors, and not working on projects are common mistakes beginners should avoid.",
  date: "Dec 12, 2025",
},
{
  title: "How Real-Time Projects Improve Placement Chances",
  image: "https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  short: "Why companies prefer candidates with project experience.",
  content:
    "Real-time projects demonstrate practical skills, teamwork, and the ability to solve real business problems, increasing employability.",
  date: "Dec 10, 2025",
},
  {
    title: "Frontend vs Backend Development: What Should You Choose?",
    image:
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
    short:
      "Understand the difference between frontend and backend roles.",
    content:
      "Frontend focuses on UI/UX and client-side logic, while backend deals with servers, databases, and APIs. Choice depends on interest and skills.",
    date: "Dec 8, 2025",
  },
  {
    title: "Why Learning Databases is Important for Developers",
    image:
      "https://images.unsplash.com/photo-1544383835-bda2bc66a55d?auto=format&fit=crop&w=800&q=80",
    short:
      "Databases play a key role in application development.",
    content:
      "Understanding databases like MySQL and MongoDB helps developers design efficient, secure, and scalable applications.",
    date: "Dec 5, 2025",
  },
  {
    title: "How Technoweit Prepares Students for the IT Industry",
    image:
      "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80",
    short:
      "Our approach towards practical IT training.",
    content:
      "Technoweit focuses on hands-on training, live projects, industry-relevant technologies, and personalized mentorship to make students job-ready.",
    date: "Dec 1, 2025",
  },
];


function Blogs() {
  const [activeBlog, setActiveBlog] = useState(null);

  return (
    <>
      
      <div className="bg-Firefly py-10 md:py-20 text-center">
        <h1 className="text-4xl font-bold text-white">Our Blogs</h1>
        <p className="mt-3 text-gray-200">
          Insights, learning tips, and technology updates
        </p>
      </div>

      <div className="bg-gray-100 py-10 md:py-20 px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {blogData.map((blog, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition overflow-hidden"
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="h-48 w-full object-cover"
              />

              <div className="p-6">
                <p className="text-sm text-gray-500 mb-1">{blog.date}</p>
                <h3 className="text-xl font-semibold text-gray-800">
                  {blog.title}
                </h3>
                <p className="mt-2 text-gray-600 text-sm">
                  {blog.short}
                </p>

                <button
                  onClick={() => setActiveBlog(blog)}
                  className="mt-4 inline-block rounded bg-black px-4 py-2 text-sm text-white"
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeBlog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
          <div className="relative w-[90%] max-w-2xl rounded-xl bg-white p-6 shadow-xl">
            <button
              onClick={() => setActiveBlog(null)}
              className="absolute top-3 right-4 text-2xl font-bold text-gray-500 hover:text-black"
            >
              ×
            </button>

            <img
              src={activeBlog.image}
              alt={activeBlog.title}
              className="mb-4 h-60 w-full rounded-lg object-cover"
            />

            <p className="text-sm text-gray-500 mb-2">
              {activeBlog.date}
            </p>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              {activeBlog.title}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {activeBlog.content}
            </p>

            <div className="mt-6 text-right">
              <button
                onClick={() => setActiveBlog(null)}
                className="rounded bg-black px-6 py-2 text-white"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Blogs;
